import { env } from "../config/env";
import {
  detectIdentityUserQuery,
  normalizeIdentityUsers,
} from "../lib/identity/searchUsers";
import type { IdentityUser } from "../types/identityUser";
import { apiRequest } from "./client";

/** GET https://chm12.ru/api/v1/users?email= | ?phone= | ?id= */
export async function searchIdentityUsers(raw: string): Promise<IdentityUser[]> {
  const query = detectIdentityUserQuery(raw);
  if (!query) return [];

  const params = new URLSearchParams(query);
  const body = await apiRequest<unknown>(`/api/v1/users?${params}`, {
    baseUrl: env.identityApiBaseUrl,
    auth: false,
  });
  return normalizeIdentityUsers(body);
}
